import i18n from "../../../../i18n";
import { defineAsyncComponent, reactive } from "vue";
import store from "../../../../store/index";
import { createPage } from "../../../../utils/page";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import { createLoading } from "../../../../utils/loading";
import { Form, Input, Skeleton } from "ant-design-vue";
import { createConditionAction } from "../sampling-product-analysis/analysis.condition";
import { callSearchAllLabTopicByProductIdAndCounties, callSearchAllLabTopicByMonitorProductId } from "../sampling-product-analysis/analysis.logic";
import { randomUuid } from "../../../../utils/util";


export const { isLoading, setIsLoading } = createLoading()

const CSelect = defineAsyncComponent({ loader: () => import('../../../../components/input/template-builder/select/CSelect'), loadingComponent: Skeleton })
const InputNumber = defineAsyncComponent({ loader: () => import('../../../../components/input/template-builder/input-number/InputNumber'), loadingComponent: Skeleton })

export const actionPrefix = "resource/v1/transaction/samplingProductAnalysisTopic";
export const routerPrefix = 'sampling-product-analysis-topics'

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria })
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria })

export const createColumns = ({ props }) => {
    const { refCountry, viewOnly, parent, isCanEditAllState } = props
    const refCountry1 = parent?.refSamplingProduct?.refCountry1
    const refCountry2 = parent?.refSamplingProduct?.refCountry2
    const refCountryIndex = refCountry?.id == null ? null : refCountry?.id === refCountry1?.id ? 1 : refCountry.id === refCountry2?.id ? 2 : null
    return [
        createColumnInput({
            title: () => i18n.global.t("model.topic.modelName"),
            dataIndex: "refLabTopic.name",
            customRender: ({ record }) => {
                return <div class="px-3">{record?.refLabTopic?.name}</div>
            },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.samplingProductAnalysisTopic.refTopicAnalysisStatus"),
            dataIndex: "refTopicAnalysisStatus.value",
            customRender: ({ record }) => {
                const topic = props.parent.topics.find(d=>d.id === record.id);
                const key = refCountryIndex === 1 ? 'refCountry1TopicAnalysisStatus' : refCountryIndex === 2 ? 'refCountry2TopicAnalysisStatus' : 'refTopicAnalysisStatus'
                const canApprove = state.conditionAction.canApprove({ props, modelRef: props.parent, initialModel: props.parent })
                const disabled = viewOnly || (!canApprove && !isCanEditAllState)
                return !topic || !topic[key] ? <span></span> : <Form.Item wrapperCol={{xs: 24}}>
                    <CSelect value={topic[key]}
                             onUpdate:value={(value) => {
                                 topic[key] = value;
                                 topic.isSave = true;
                             }}
                             list={({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'ACCEPT_STATUS', value: searchQuery, key: ['Accept', 'Reject'], keyOperator: 'in', valueLogic: 'AND' })}
                             optKey="key"
                             optLabel="key"
                             disabled={disabled}
                    ></CSelect>
                </Form.Item>
            },
        }),
        createColumnInput({
            visible: () => false,
            title: () => i18n.global.t('model.samplingProductAnalysisTopic.labels.calculate'),
            search: { visible: () => false },
            align: 'center',
            sorter: false,
            customRender: ({record}) => {
                const topic = props.parent.topics.find(d=>d.id === record.id);
                const results = topic.inputs?.filter(d=>d?.results?.length > 0).flatMap(d=>d.results).filter(d=>d.refCountry?.id === refCountry?.id ) || []
                if (results.length === 0) { results.push({}) }
                const inputsJsx = results?.map(d => {
                    return <Form.Item wrapperCol={{xs: 24}}>
                        <Input
                            value={!d.refResultStatus ? '' : i18n.global.t('model.samplingProductAnalysisTopic.labels.calculated')}
                            disabled={true}
                        ></Input>
                    </Form.Item>
                }) || []
                return <div>{...inputsJsx}</div>
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInput.realValue'),
            dataIndex: 'realValue',
            search: { visible: () => false },
            align: 'left',
            sorter: false,
            customRender: ({record}) => {
                const topic = props.parent.topics.find(d=>d.id === record.id);
                const inputsJsx = topic?.inputs?.map(d =>
                    <Form.Item wrapperCol={{xs: 24}}>
                        <InputNumber
                            value={d.realValue}
                            allowPrecision={true}
                            maxPrecision={2}
                            comma={false}
                            disabled={true}
                            placeholder={i18n.global.t('model.samplingProductAnalysisTopicInput.realValue')}
                        ></InputNumber>
                    </Form.Item>
                ) || []
                return <div>{...inputsJsx}</div>
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInputCountryResult.refResultStatus'),
            search: { visible: () => false },
            align: 'center',
            sorter: false,
            customRender: ({record}) => {
                const topic = props.parent.topics.find(d=>d.id === record.id) || record;
                const { refCountry } = props;
                const results = reactive([]);
                for (const input of topic.inputs) {
                    for (const result of input.results || []) {
                        if (!input.isDelete && !result.isDelete && result.refCountry?.id == refCountry?.id) {
                            results.push(result)
                        }
                    }
                }
                if (results.length === 0) {
                    return <span></span>;
                }
                const inputsJsx = results?.map(d => {
                    const canApprove = state.conditionAction.canApprove({ props, modelRef: props.parent, initialModel: props.parent })
                    const disabled = viewOnly || !d?.id || (!canApprove && !isCanEditAllState)
                    return <Form.Item wrapperCol={{xs: 24}}>
                        <CSelect value={d.refResultStatus}
                                 onUpdate:value={(value) => {
                                     d.refResultStatus = value
                                     d.isSave = true
                                     const input = topic.inputs.find(it=>it.results.find(r=>r.id===d.id))
                                     if (input) input.isSave = true
                                     topic.isSave = true
                                 }}
                                 list={({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'ACCEPT_STATUS', value: searchQuery, key: ['Accept', 'Reject'], keyOperator: 'in', valueLogic: 'AND' })}
                                 optKey="key"
                                 optLabel="key"
                                 disabled={disabled}
                        ></CSelect>
                    </Form.Item>
                }) || []
                return <div>{...inputsJsx}</div>
            }
        }),
        createColumnInput({
            title: () => i18n.global.t('model.samplingProductAnalysisTopicInputCountryResult.labels.standard'),
            search: { visible: () => false },
            align: 'center',
            sorter: false,
            customRender: ({record}) => {
                const topic = props.parent.topics.find(d=>d.id && d.id === record.id) || record;
                const results = reactive([]);
                for (const input of topic.inputs) { for (const result of input.results || []) { if (!input.isDelete && !result.isDelete) { results.push(result) } } }
                if (results?.length > 0) {
                    const standard = results[0];
                    if (standard?.stdLabFormula === 'n c m M') {
                        return <div>
                            <div>n = {standard.stdN}</div>
                            <div>c = {standard.stdC}</div>
                            <div>m = {standard.stdM}</div>
                            <div>M = {standard.stdMBig}</div>
                        </div>
                    } else if (standard?.stdLabFormula === 'Operator') {
                        return <div>{standard.stdMathSymbol}{standard.stdMathValue}</div>
                    } else if (standard?.stdLabFormula === 'Detected') {
                        return <div>Detected = {standard.stdIsDetect ? 1 : 0}</div>
                    }
                }
                return <div>ไม่มีข้อมูล</div>
            }
        }),
    ]
}

export const loadDefaultForm = ({ props, data }) => {
    const { parent, refCountry } = props;
    const promises = [];
    const labTypeKey = parent?.refLabType?.key
    const samplingRequestTypeKey = parent?.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key;
    if (["L", "S"].includes(samplingRequestTypeKey)) {
        const countryId1 = refCountry?.id;
        /* !!! Read Me  CR 06/10/2566
        *      ทุกรายการผลิตภัณฑ์ตอนสุ่มตรวจให้ใช้มาตรฐาน LOT BY LOT ทำให้  ยกเลิก *** countryIdDof = "99999999-9999-9999-9999-999999999999" ที่เป็นมาตรฐานของสิทธิพิเศษ
        * */
        // const countryIdDof = "99999999-9999-9999-9999-999999999999";
        const productId = parent?.refSamplingProduct?.refCompanyProduct?.refProduct?.id;

        // const cid = samplingRequestTypeKey === "S" ? countryIdDof : countryId1;
        // const call1 = callSearchAllLabTopicByProductIdAndCounties({ labTypeKey, productId, countryId1: cid }).then(res => {

        const call1 = callSearchAllLabTopicByProductIdAndCounties({ labTypeKey, productId, countryId1: countryId1 }).then(res => {
            data.standards = res.map(d=>({
                _id: randomUuid(),
                refCountry: refCountry,
                refLabTopic: d.refLabTopic,
                stdLabFormula: d.labFormula,
                stdMathSymbol: d.mathSymbol,
                stdMathValue: d.operatorValue,
                stdIsDetect: d.isDetected,
                stdN: d.n,
                stdC: d.c,
                stdM: d.m,
                stdMBig: d.mUpper,
            }))
        });
        promises.push(call1);
    } else if ("M" === samplingRequestTypeKey) {
        const productId = parent?.refSamplingProduct?.refSamplingMonitorProduct?.id;
        const call1 = callSearchAllLabTopicByMonitorProductId({ labTypeKey, productId }).then(res => {
            data.standards = res.map(d=>({
                _id: randomUuid(),
                refLabTopic: d.refLabTopic,
                stdLabFormula: d.refLabTopic?.refLabFormula?.key,
                stdMathSymbol: d.mathSymbol,
                stdMathValue: d.operatorValue,
                stdIsDetect: d.isDetected,
                stdN: d.n,
                stdC: d.c,
                stdM: d.m,
                stdMBig: d.mUpper,
            }))
        });
        promises.push(call1);
    }
    setIsLoading(true);
    return Promise.all(promises)
        .finally(() => setIsLoading(false));
}


export const initData = ({ props, data }) => {
    data.columns = createColumns({ props, data })
    loadDefaultForm({ props, data }).then(() => {
        const topics = props.parent.topics?.filter(record => (record.inputs?.filter(d=>d?.results?.length > 0).flatMap(d=>d.results).filter(d=>!props.refCountry?.id || d.refCountry?.id == props.refCountry?.id) || []).length > 0)
        data.standards?.forEach(d => {
            const exist = topics.find(t=>t.refLabTopic?.id === d.refLabTopic?.id)
            if (!exist) {
                topics.push(reactive({
                    refLabTopic: d.refLabTopic,
                    inputs: [{
                        results: [{ ...d }]
                    }]
                }))
            }
        });

        data.page = createPage({ data: topics });
        data.tableOptions = { search: { activeKey: null } };
        data.manages = [];
        data.manageExtras = [];
        data.rowActions = []

    })
}

export const state = reactive({
    page: createPage({ options: { select: ['**'] } }),
    tableOptions: { search: { activeKey: 'Search' } },
    conditionAction: createConditionAction(),
})
